import { LockClosedIcon } from '@heroicons/react/24/outline'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const navigationItems = [{ to: 'security', label: 'shell.securityNav', icon: LockClosedIcon }] as const

export const AccountNavigation = () => {
    const { t } = useTranslation()

    if (navigationItems.length < 2) {
        return null
    }

    return (
        <nav aria-label={t('shell.navigation')} className="flex flex-wrap gap-2">
            {navigationItems.map(({ to, label, icon: Icon }) => (
                <NavLink
                    key={to}
                    to={to}
                    className={({ isActive }) =>
                        isActive
                            ? 'border-account-divider bg-account-surface text-account-accent-text flex items-center gap-3 rounded-lg border px-3 py-2.5 font-semibold shadow-sm'
                            : 'text-account-primary hover:bg-account-hover hover:text-account-strong flex items-center gap-3 rounded-lg border border-transparent px-3 py-2.5 font-semibold transition'
                    }
                >
                    {({ isActive }) => (
                        <>
                            <Icon className={`h-5 w-5 ${isActive ? 'opacity-75' : 'text-account-faint'}`} />
                            {t(label)}
                        </>
                    )}
                </NavLink>
            ))}
        </nav>
    )
}
